export default __webpack_public_path__ + "Kuantum4.pdf";